import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "@/App.css";

import SplashScreen from "@/components/SplashScreen";
import ScrollProgress from "@/components/ScrollProgress";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import AgitationSection from "@/components/AgitationSection";
import MethodSection from "@/components/MethodSection";
import AuthoritySection from "@/components/AuthoritySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ProcessSection from "@/components/ProcessSection";
import FaqSection from "@/components/FaqSection";
import CtaSection from "@/components/CtaSection";
import FooterSection from "@/components/FooterSection";

function App() {
  const [splashDone, setSplashDone] = useState(false);

  // Hide Emergent badge
  useEffect(() => {
    const hide = () => {
      const el = document.getElementById('emergent-badge');
      if (el) el.style.setProperty('display', 'none', 'important');
    };
    hide();
    const t = setTimeout(hide, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div>
      {/* Splash Screen */}
      <AnimatePresence>
        {!splashDone && (
          <SplashScreen key="splash" onComplete={() => setSplashDone(true)} />
        )}
      </AnimatePresence>

      {/* Main Content — only mount after splash so animations trigger correctly */}
      {splashDone && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      >
        <ScrollProgress />
        <Navigation />
        <main>
          <HeroSection />
          <AgitationSection />
          <MethodSection />
          <AuthoritySection />
          <TestimonialsSection />
          <ProcessSection />
          <FaqSection />
          <CtaSection />
        </main>
        <FooterSection />
      </motion.div>
      )}
    </div>
  );
}

export default App;
